/**
 * @generated SignedSource<<4a1af281a7150780dccf16684174438f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraProjectRecommendationType = "INVITER_ACTIVITY" | "TENANT_ACTIVITY" | "%future added value";
export type JiraProjectStyle = "COMPANY_MANAGED_PROJECT" | "TEAM_MANAGED_PROJECT" | "%future added value";
export type JiraProjectType = "BUSINESS" | "CUSTOMER_SERVICE" | "PRODUCT_DISCOVERY" | "SERVICE_DESK" | "SOFTWARE" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type RecommendationCard_recommendation$data = {
  readonly details: {
    readonly inviter?: {
      readonly name: string;
    } | null | undefined;
    readonly recommendationType?: JiraProjectRecommendationType;
  };
  readonly project: {
    readonly avatar: {
      readonly medium: string;
    };
    readonly key: string;
    readonly name: string;
    readonly projectId: string;
    readonly projectStyle: JiraProjectStyle;
    readonly projectType: JiraProjectType;
  };
  readonly " $fragmentType": "RecommendationCard_recommendation";
};
export type RecommendationCard_recommendation$key = {
  readonly " $data"?: RecommendationCard_recommendation$data;
  readonly " $fragmentSpreads": FragmentRefs<"RecommendationCard_recommendation">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "RequiredField",
  "field": {
    "kind": "ScalarField",
    "name": "recommendationType"
  },
  "action": "THROW",
  "path": "details.recommendationType"
},
v1 = {
  "kind": "ScalarField",
  "name": "name"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "RecommendationCard_recommendation",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "LinkedField",
        "name": "details",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v0/*: any*/)
            ],
            "type": "JiraTenantActivityRecommendation"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v0/*: any*/),
              {
                "kind": "LinkedField",
                "name": "inviter",
                "plural": false,
                "selections": [
                  {
                    "kind": "RequiredField",
                    "field": (v1/*: any*/),
                    "action": "THROW",
                    "path": "details.inviter.name"
                  }
                ]
              }
            ],
            "type": "JiraInviterActivityRecommendation"
          }
        ]
      },
      "action": "THROW",
      "path": "details"
    },
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "JiraProject",
        "kind": "LinkedField",
        "name": "project",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "kind": "ScalarField",
              "name": "projectId"
            },
            "action": "THROW",
            "path": "project.projectId"
          },
          {
            "kind": "RequiredField",
            "field": {
              "kind": "ScalarField",
              "name": "key"
            },
            "action": "THROW",
            "path": "project.key"
          },
          {
            "kind": "RequiredField",
            "field": (v1/*: any*/),
            "action": "THROW",
            "path": "project.name"
          },
          {
            "kind": "RequiredField",
            "field": {
              "kind": "ScalarField",
              "name": "projectStyle"
            },
            "action": "THROW",
            "path": "project.projectStyle"
          },
          {
            "kind": "RequiredField",
            "field": {
              "kind": "ScalarField",
              "name": "projectType"
            },
            "action": "THROW",
            "path": "project.projectType"
          },
          {
            "kind": "RequiredField",
            "field": {
              "concreteType": "JiraAvatar",
              "kind": "LinkedField",
              "name": "avatar",
              "plural": false,
              "selections": [
                {
                  "kind": "RequiredField",
                  "field": {
                    "kind": "ScalarField",
                    "name": "medium"
                  },
                  "action": "THROW",
                  "path": "project.avatar.medium"
                }
              ]
            },
            "action": "THROW",
            "path": "project.avatar"
          }
        ]
      },
      "action": "THROW",
      "path": "project"
    }
  ],
  "type": "JiraProjectRecommendation"
};
})();

(node as any).hash = "42a35b07da0ba347dd00dc19f5971672";

export default node;
